import { Calendar, DatePicker } from "@bcc-ui/ui-components";
import * as React from "react";

import { DATE_FORMAT } from "utils/format";
import { useTheme } from "utils/useTheme";

const MAX_EXPIRATION_YEARS = 5;
const POPUP_CLASS_NAME = "publicLinkExpirationDatePickerPopup";

// The backend rejects expirations more than 5 years from now. It expires links at the end of the chosen date in UTC.
// The last selectable day is the one before the 5-year mark.
const getLatestExpiration = (): Date => {
    const latest = new Date();
    latest.setFullYear(latest.getFullYear() + MAX_EXPIRATION_YEARS);
    latest.setDate(latest.getDate() - 1);
    return latest;
};

export const getDefaultPublicLinkExpiration = (): Date => {
    const oneYearFromToday = new Date();
    oneYearFromToday.setFullYear(oneYearFromToday.getFullYear() + 1);
    return oneYearFromToday;
};

const startOfTomorrow = (): number => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.setHours(0, 0, 0, 0);
};

export const isPublicLinkExpirationDisabled = (date: Date): boolean =>
    date.getTime() < startOfTomorrow() || date.getTime() > getLatestExpiration().getTime();

interface Props {
    name: string;
    label?: string;
    value: Date;
    onChange: (date: Date) => void;
    testId: string;
}

export const PublicLinkExpirationDatePicker = (props: Props) => {
    const theme = useTheme();
    return (
        <DatePicker
            name={props.name}
            fieldLabel={props.label}
            caretAs={() => <Calendar color={theme.iconFillColor} />}
            placement="bottomStart"
            menuClassName={POPUP_CLASS_NAME}
            format={DATE_FORMAT}
            value={props.value}
            onChange={(date) => date && props.onChange(date)}
            cleanable={false}
            shouldDisableDate={isPublicLinkExpirationDisabled}
            testId={props.testId}
        />
    );
};
